<template>
  <div>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
    <b-container fluid>
      <userNoField></userNoField>
      <hr>
      <b-alert variant="info" :show="isAlreadyClosed">測定会は終了しました</b-alert>
      <b-card no-body>
        <b-list-group v-if="currentUserGroupId">
          <b-list-group-item>
            <b-btn variant="link" @click="$router.push('/usergroups/' + currentUserGroupId + '/members')"><i class="fas fa-address-card"></i> 参加者一覧 ({{currentUserGroup.members ? currentUserGroup.members.length : 0}}名)</b-btn>
          </b-list-group-item>
          <b-list-group-item>
            <b-btn variant="link" @click="$router.push('/usergroups/' + currentUserGroupId + '/user/new')"><i class="fas fa-user-plus"></i> 参加者受付</b-btn>
          </b-list-group-item>
          <b-list-group-item>
            <b-btn variant="link" @click="$router.push('/usergroups/' + currentUserGroupId + '/userfelica')"><i class="fas fa-weight"></i> 体組成計</b-btn>
          </b-list-group-item>
          <b-list-group-item>
            <b-btn variant="link" @click="$router.push('/usergroups/' + currentUserGroupId + '/felicas/new')"><i class="fas fa-credit-card"></i> Felicaカード登録</b-btn>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-container>
    <hr>
    <div class="mb-2">
      <b-btn variant="secondary" block @click="$router.push('/')">
        <span>戻る</span>
      </b-btn>
    </div>
  </div>
</template>

<script>
import userNoField from '@/pages/userGroups/UserNoField'
import { Logger } from 'aws-amplify'

const logger = new Logger('Dashboard')

export default {
  name: 'UserGroupTop',
  data () {
    return {
      loading: false,
      message: null,
      error: null
    }
  },
  components: {
    userNoField
  },
  computed: {
    userGroups () {
      return this.$store.getters.userGroups
    },
    userGroupOptions () {
      let groups = this.$store.getters.userGroups
      let options = []
      options = groups.map(g => {
        return { value: g.groupId, text: g.name }
      })
      return options
    },
    currentUserGroup () {
      return this.$store.getters.currentUserGroup
    },
    currentUserGroupId () {
      let curr = this.$store.getters.currentUserGroup
      return curr && curr.groupId
    },
    isAlreadyClosed () {
      return this.$store.getters.currentUserGroup.closedAt > new Date().getTime()
    }
  },
  mounted () {
  },
  methods: {
    loadItems () {
      if (!this.$store.getters.userGroups || this.$store.getters.userGroups.length < 1) {
        this.message = null
        this.error = null
        return new Promise((resolve) => {
          setTimeout(() => {
            return this.$store.dispatch('fetchUserGroups').then((userGroups) => {
              // this.userGroups = userGroups
            }).catch(err => {
              logger.error(err)
              this.error = err.message || err
            })
          }, 1000)
        })
      }
    },
    refreshItems () {
      return this.loadItems()
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, .05);
}
</style>
